const PricingHero = () => {
  return (
    <section 
      className="section-padding bg-coderide-black relative" 
      style={{
        backgroundImage: `url('https://ideybnueizkxwqmjowpy.supabase.co/storage/v1/object/sign/coderide-website/cr_bg_2.webp?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJjb2RlcmlkZS13ZWJzaXRlL2NyX2JnXzIud2VicCIsImlhdCI6MTc0NDk2MTQwNywiZXhwIjoxNzc2NDk3NDA3fQ.IfeUNJDzKofonFVKJ4W7xXhMNEFh392WSjUZ98qCVXs')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-coderide-black/50"></div>
      <div className="container relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 drop-shadow-lg">
            Choose Your CodeRide Plan
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-8 max-w-3xl mx-auto drop-shadow leading-relaxed">
            Scale your AI coding experience with the <strong className="font-semibold text-white">right plan</strong> for you. 
            From exploring CodeRide to professional development with <span className="bg-[#7867EE] text-white px-2 py-1 rounded font-mono">persistent context</span> management.{" "}
            <button 
              onClick={() => window.open('https://app.coderide.ai/auth/sign-up', '_blank')}
              className="inline-flex items-center text-lg font-bold text-coderide-light-blue hover:text-white transition-colors"
            >
              <span className="underline">Start exploring</span> →
            </button>
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-white/80">
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-coderide-light-blue" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>No setup fees</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-coderide-light-blue" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>Cancel anytime</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-coderide-light-blue" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>Start free</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingHero;
